import { AT } from "./actionTypes";
import { TAction, TState } from "./types";

export default function Reducer(state: TState, action: TAction): TState {
  switch (action.type) {
    case AT.SET_USER: {
      const _ = { ...state };
      _.user = action.payload;

      if (!action.payload) {
        _.provider = null;
        _.settings = { color: "#1cd494", type: "customer" };
        localStorage.removeItem("userType");
      }

      return _;
    }
    case AT.SET_ALERT: {
      return { ...state, alert: action.payload };
    }
    case AT.SET_ISOCODE: {
      return { ...state, isocode: action.payload };
    }
    case AT.SET_PROVIDER: {
      return { ...state, provider: action.payload };
    }
    case AT.SET_SETTINGS: {
      return { ...state, settings: action.payload };
    }
    default:
      return state;
  }
}
